import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import jwt from 'jsonwebtoken';
import s from './Dashboard.module.scss';
import './main.css'

import { USER_ROLE } from '../../constants';
import moment from 'moment';
import EditorArea from './EditorArea';
import { Link } from 'react-router-dom';
import axios from "axios";

class Pricing extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currUser: {},
      modalToggleNewDashboard: false,
      newDashboard: { title: '', body: '', highlight: false, code: '', codeHN: '', codeDN: '', location: 'HCM', type: 'item', parentId: null },
      modalToggleNewGroup: false,
      newGroup: { title: '', body: '', type: 'group', location: 'HCM', parentId: null },
      isOpenToast: false,
      data: {
        total: 0,
        list: [],
        size: 20,
        from: 0,
        page: 1
      },
      selectedLocation: 'HCM',
      expandedGroups: {},
      loading: false,
    };
    this.onAddnewDashboard = this.onAddnewDashboard.bind(this);
    this.onChangeNewDashboard = this.onChangeNewDashboard.bind(this);
    this.toggleNewDashboard = this.toggleNewDashboard.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
    this.onAddNewGroup = this.onAddNewGroup.bind(this);
    this.onChangeNewGroup = this.onChangeNewGroup.bind(this);
    this.toggleNewGroup = this.toggleNewGroup.bind(this);
    this.changeLocationGroup = this.changeLocationGroup.bind(this);
    this.setLocation = this.setLocation.bind(this);
    this.toggleGroup = this.toggleGroup.bind(this);
    this.deletePricing = this.deletePricing.bind(this);
  }

  deletePricing(id, title) {
    confirmAlert({
      title: 'Xác nhận Xoá',
      message: `Bạn có chắc muốn xoá "${title}" không? Hành động này không thể hoàn tác.`,
      buttons: [
        {
          label: 'Có, Xoá ngay',
          onClick: async () => {
            try {
              await axios.get(`/delete-pricing/${id}`);
              toast.success('Xoá thành công');
              this.getAllDashboard();
            } catch (err) {
              toast.error('Có lỗi xảy ra khi xoá');
            }
          },
        },
        { label: 'Huỷ', onClick: () => {} },
      ],
    });
  }

  toggleGroup(id) {
    this.setState(prevState => ({
      expandedGroups: {
        ...prevState.expandedGroups,
        [id]: !prevState.expandedGroups[id]
      }
    }));
  }

  buildTree(items) {
    const map = {};
    const tree = [];

    items.forEach(item => {
      map[item.id] = { ...item, children: [] };
    });

    items.forEach(item => {
      if (item.parentId && map[item.parentId]) {
        map[item.parentId].children.push(map[item.id]);
      } else {
        tree.push(map[item.id]);
      }
    });

    return tree;
  }

  renderTreeOptions(nodes, level = 0) {
    let options = [];
    nodes.forEach(node => {
      if (node.type === 'group') {
        options.push(
          <option key={node.id} value={node.id}>
            {'\u00A0'.repeat(level * 4)}{level > 0 ? '↳ ' : ''}{node.title}
          </option>
        );
        if (node.children && node.children.length > 0) {
          options = options.concat(this.renderTreeOptions(node.children, level + 1));
        }
      }
    });
    return options;
  }

  toggleNewDashboard() {
    this.setState({
      modalToggleNewDashboard: !this.state.modalToggleNewDashboard,
    });
  }
  setLocation(val) {
    const { data } = this.state
    this.setState({ selectedLocation: val })
    let list = data.list ? data.list.filter(i => i.location == val) : [];
    this.setState({ list: list })
  }

  async onAddnewDashboard(e) {
    e.preventDefault();
    try {
      console.log(this.state.newDashboard)
      await axios.post('/create-pricing', this.state.newDashboard)
      await this.getAllDashboard()
      this.toggleNewDashboard();
      this.setState({
        isOpenToast: true,
        newDashboard: { title: '', body: '', highlight: false, code: '', codeDN: '', codeHN: '', location: 'HCM', type: 'item', parentId: null },
      });
    } catch (err) {
      toast.error('Đã có lỗi xảy ra ', err.error);
      return
    }
  }

  onChangeNewDashboard(e, name) {
    if (name) {
      this.setState({
        newDashboard: {
          ...this.state.newDashboard,
          [name]: e,
        },
      });
      return;
    }
    this.setState({
      newDashboard: {
        ...this.state.newDashboard,
        [e.target.name]: e.target.value,
      },
    });
  }

  changeLocation(e) {
    const { name, value } = e.target;
    let newDashboard = this.state.newDashboard
    newDashboard[name] = value
    this.setState({ newDashboard: newDashboard })
  }

  toggleNewGroup() {
    this.setState({
      modalToggleNewGroup: !this.state.modalToggleNewGroup,
    });
  }

  async onAddNewGroup(e) {
    e.preventDefault();
    try {
      await axios.post('/create-pricing', this.state.newGroup)
      await this.getAllDashboard()
      this.toggleNewGroup();
      this.setState({
        isOpenToast: true,
        newGroup: { title: '', body: '', type: 'group', location: 'HCM', parentId: null },
      });
    } catch (err) {
      toast.error('Đã có lỗi xảy ra ', err.error);
    }
  }

  onChangeNewGroup(e, name) {
    if (name) {
      this.setState({
        newGroup: {
          ...this.state.newGroup,
          [name]: e,
        },
      });
      return;
    }
    this.setState({
      newGroup: {
        ...this.state.newGroup,
        [e.target.name]: e.target.value,
      },
    });
  }

  changeLocationGroup(e) {
    const { name, value } = e.target;
    let newGroup = this.state.newGroup
    newGroup[name] = value
    this.setState({ newGroup: newGroup })
  }

  async componentDidMount() {
    let token = localStorage.getItem('id_token');
    let currUser = jwt.decode(token);
    this.setState({ currUser: currUser });

    await this.getAllDashboard()
  }

  async getAllDashboard(params = {}) {
    try {
      const { searchBy, search = '' } = this.state
      this.setState({ loading: true })
      let res
      let url = `/get-all-pricing?size=all&search=${search}&status=${this.state.qStatus}`
      if (searchBy === 'owner') {
        url += `&searchBy=${searchBy}`
      }
      if (this.state.currUser.role === USER_ROLE.SALER || this.state.currUser.role === USER_ROLE.CONSULTANT || this.state.currUser.role === USER_ROLE.OPS) {
        url += `&owner=${this.state.currUser.displayName}`
      }
      res = await axios.get(url)
      if (res && res.data) {
        console.log(res.data, this.state.selectedLocation)
        let list = res.data && res.data.list ? res.data.list.filter(i => i.location == this.state.selectedLocation) : [];
        this.setState({ data: res.data, list })
      }
      this.setState({ loading: false })
    } catch (e) {
      console.error(e)
      this.setState({ loading: false })
    }
  }

  renderTree(items, level = 0) {
    const { expandedGroups } = this.state;
    return items.map(item => {
      const isGroup = item.type === 'group';
      const isExpanded = expandedGroups[item.id];

      return (
        <React.Fragment key={item.id}>
          <div className={cx(s.pricingCard, isGroup ? s.pricingCardGroup : s.pricingCardItem)}>
            <div className={s.cardLeft} style={{ paddingLeft: `${level * 20}px` }}>
              {isGroup ? (
                <div
                  className={s.toggleIcon}
                  onClick={() => this.toggleGroup(item.id)}
                >
                  <i className={cx('fa', isExpanded ? 'fa-minus' : 'fa-plus')} />
                </div>
              ) : (
                <div className={s.itemIcon}>
                  <i className="fa fa-file-text-o" />
                </div>
              )}

              <div className="flex-grow-1">
                {isGroup ? (
                  <Link to={`/app/pricing/group/${item.id}`} className={s.cardTitle}>
                    <span className={s.title}>
                      {item.title || 'Nhóm chưa đặt tên'}
                    </span>
                  </Link>
                ) : (
                  <Link to={`/app/pricing/${item.id}`} className={s.cardTitle}>
                    <span className={cx(s.title, { 'text-danger fw-bold': item.highlight })}>
                      {item.title || 'Bảng giá chưa đặt tên'}
                    </span>
                  </Link>
                )}
              </div>
            </div>

            <div className={s.cardMeta}>
              <div className="mr-3">
                <i className="fa fa-clock-o mr-1" />
                {moment(item.updatedAt).fromNow()}
              </div>
              {this.state.currUser.role === USER_ROLE.ADMIN && (
                <button 
                  className={s.btnDeleteSmall}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.deletePricing(item.id, item.title);
                  }}
                  title="Xoá"
                >
                  <i className="fa fa-trash-o" />
                </button>
              )}
            </div>
          </div>
          {isGroup && isExpanded && (
            <div className={s.nestedWrapper}>
              {this.renderTree(item.children, level + 1)}
            </div>
          )}
        </React.Fragment>
      );
    });
  }

  render() {
    const { data, selectedLocation, list, loading } = this.state;
    const treeData = this.buildTree(list || []);
    const groups = (list || []).filter(item => item.type === 'group');

    const locations = [
      { id: 'HCM', label: 'Hồ Chí Minh' },
      { id: 'HN', label: 'Hà Nội' },
      { id: 'ĐN', label: 'Đà Nẵng' },
      { id: 'Custom', label: 'GIÁ BÁN THAM KHẢO' },
    ];

    return (
      <div className={s.root}>
        <ToastContainer position='top-right' autoClose={3000} hideProgressBar />

        {/* Breadcrumbs */}
        <div className={s.breadcrumbContainer}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Hệ thống</li>
              <li className="breadcrumb-item active" aria-current="page">Bảng giá vận chuyển</li>
            </ol>
          </nav>
        </div>

        {/* Header */}
        <div className={s.headerRow}>
          <div className={s.titleSection}>
            <h2>Bảng giá dịch vụ</h2>
            <p>Tra cứu cước vận tải và các phụ phí theo khu vực</p>
          </div>

          {this.state.currUser.role === USER_ROLE.ADMIN && (
            <div className={s.actionGroup}>
              <button className={cx(s.btnPremium, s.btnPremiumGroup)} onClick={this.toggleNewGroup}>
                <i className='fa fa-folder' /> Thêm nhóm
              </button>
              <button className={cx(s.btnPremium, s.btnPremiumAdd)} onClick={this.toggleNewDashboard}>
                <i className='fa fa-plus-circle' /> Thêm bảng giá
              </button>
            </div>
          )}
        </div>

        {/* Location Tabs */}
        <div className={s.tabSystem}>
          {locations.map(loc => (
            <div
              key={loc.id}
              className={cx(s.tabItem, { [s.active]: selectedLocation === loc.id })}
              onClick={() => this.setLocation(loc.id)}
            >
              {loc.label}
            </div>
          ))}
        </div>

        {/* Content List */}
        <div className={s.listContainer}>
          {loading ? (
            <div className="text-center py-5">
              <i className="fa fa-circle-o-notch fa-spin fa-2x text-primary" />
              <p className="mt-2 text-muted">Đang tải dữ liệu...</p>
            </div>
          ) : treeData && treeData.length > 0 ? (
            this.renderTree(treeData)
          ) : (
            <div className={s.pricingCard} style={{ justifyContent: 'center', padding: '40px' }}>
              <div className="text-center text-muted">
                <i className="fa fa-inbox fa-3x mb-3 opacity-20" />
                <p>Chưa có bảng giá nào ở khu vực này</p>
              </div>
            </div>
          )}
        </div>

        <Modal
          isOpen={this.state.modalToggleNewDashboard}
          toggle={this.toggleNewDashboard}
          size="lg"
        >
          <ModalHeader>Tạo bảng giá mới</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='title'>Tiêu đề</Label>
              <Input
                value={this.state.newDashboard.title}
                name='title'
                id='title'
                placeholder='Nhập tiêu đề bảng giá...'
                onChange={(e) => this.onChangeNewDashboard(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label for='parentId'>Thuộc nhóm</Label>
              <Input
                type="select"
                name="parentId"
                id="parentId"
                value={this.state.newDashboard.parentId || ''}
                onChange={(e) => this.onChangeNewDashboard(e)}
              >
                <option value="">-- Không thuộc nhóm nào (Gốc) --</option>
                {this.renderTreeOptions(treeData)}
              </Input>
            </FormGroup>
            <FormGroup style={{ minHeight: '400px' }}>
              <Label for='content'>Nội dung chi tiết</Label>
              <EditorArea
                value={this.state.newDashboard.body}
                onChange={(e) => this.onChangeNewDashboard(e, 'body')}
              />
            </FormGroup>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="location">Khu vực hiển thị</Label>
                  <Input id="location" name="location" value={this.state.newDashboard.location} type="select" onChange={this.changeLocation}>
                    <option value="HCM">Hồ Chí Minh</option>
                    <option value="HN">Hà Nội</option>
                    <option value="ĐN">Đà Nẵng</option>
                    <option value="Custom">GIÁ BÁN THAM KHẢO</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="d-flex align-items-center h-100 pt-3">
                  <div className="abc-checkbox abc-checkbox-danger">
                    <Input
                      id="highlight"
                      name="highlight"
                      type="checkbox"
                      checked={this.state.newDashboard.highlight}
                      onChange={(e) => this.onChangeNewDashboard({ target: { name: 'highlight', value: e.target.checked } })}
                    />
                    <Label for="highlight">Nổi bật (Chữ đỏ)</Label>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for='code'>Link Embed (Nếu có)</Label>
              <Input
                type="textarea"
                value={this.state.newDashboard.code}
                name='code'
                id='code'
                placeholder='Dán link hoặc mã embed vào đây...'
                onChange={(e) => this.onChangeNewDashboard(e)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color='success' className="px-4" onClick={(e) => this.onAddnewDashboard(e)}>Lưu lại</Button>
            <Button color='secondary' onClick={this.toggleNewDashboard}>Đóng</Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.modalToggleNewGroup}
          toggle={this.toggleNewGroup}
        >
          <ModalHeader>Tạo nhóm mới</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='titleGroup'>Tên nhóm</Label>
              <Input
                value={this.state.newGroup.title}
                name='title'
                id='titleGroup'
                placeholder='Ví dụ: Cước tàu biển, Phụ phí...'
                onChange={(e) => this.onChangeNewGroup(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label for='parentIdGroup'>Thuộc nhóm cha (Nếu có)</Label>
              <Input
                type="select"
                name="parentId"
                id="parentIdGroup"
                value={this.state.newGroup.parentId || ''}
                onChange={(e) => this.onChangeNewGroup(e)}
              >
                <option value="">-- Cấp gốc (Root) --</option>
                {this.renderTreeOptions(treeData)}
              </Input>
            </FormGroup>
            <FormGroup style={{ minHeight: '300px' }}>
              <Label for='contentGroup'>Mô tả chi tiết nhóm</Label>
              <EditorArea
                value={this.state.newGroup.body}
                onChange={(e) => this.onChangeNewGroup(e, 'body')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="locationGroup">Khu vực</Label>
              <Input id="locationGroup" name="location" value={this.state.newGroup.location} type="select" onChange={this.changeLocationGroup}>
                <option value="HCM">Hồ Chí Minh</option>
                <option value="HN">Hà Nội</option>
                <option value="ĐN">Đà Nẵng</option>
                <option value="Custom">GIÁ BÁN THAM KHẢO</option>
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color='primary' className="px-4" onClick={(e) => this.onAddNewGroup(e)}>Tạo nhóm</Button>
            <Button color='secondary' onClick={this.toggleNewGroup}>Huỷ</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default Pricing
